import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

const QualityView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(261)); 
      console.log(permission);

      axios
      .get(`/qualities/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.quality);
          console.log(response.data.data.quality);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  let raw_data_invoice ='';
  if(value.file){
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: value.file};
    raw_data_invoice = s3.getSignedUrl('getObject', params);
  
  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Lab Analysis View</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/qualities">Lab Analysis</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Lab Analysis
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                    {permission && permission.list == 1 && (
                      <div className="card-body">
                        <h4 className="card-title">Lab Analysis Info</h4>
                        <table className="table table-bordered">
                          <tr>
                            <th className="p-3">Analysis Name</th>
                            <td className="p-3">{value.analysis_name}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Lab Name</th>
                            <td className="p-3">{value.lab_name}</td>
                          </tr>
                          <tr>
                            <th className="p-3">RM Lot or Farm</th>
                            <td className="p-3">{value.ram_lot_or_farm}</td>
                          </tr>
                          <tr>
                            <th className="p-3">Farm Name</th>
                            <td className="p-3">
                              {value.farm_detail ? value.farm_detail.name : ""}
                            </td>
                          </tr>
                          <tr>
                            <th className="p-3">Processing Line</th>
                            <td className="p-3">
                              {value.location ? value.location.title : ""}
                            </td>
                          </tr>
                          <tr>
                            <th className="p-3">Product Name</th>
                            <td className="p-3">
                              {value.product ? value.product : ""}
                            </td>
                          </tr>
                        
                          <tr>
                            <th className="p-3">Date</th>
                            <td className="p-3">{value.date}</td>
                          </tr>
                          <tr>
                            <th className="p-3">price</th>
                            <td className="p-3">
                                {parseFloat(value.price).toFixed(2)}{value.quality_currency
                                ? value.quality_currency.symbol
                                : ""}
                            </td>
                          </tr>
                        
                          {raw_data_invoice != '' && (
                              <tr>
                              <th className="p-3">File</th>
                              <td className="p-3">
                                <a
                                  className="btn btn-primary invoicebtn"
                                  href={raw_data_invoice}
                                  target="_blank"
                                   rel="noopener noreferrer"
                                  download
                                >
                                  Download
                                </a>
                              </td>
                            </tr>
                          )}
                        <tr>
                            <th className="p-3">Note</th>
                            <td className="p-3">{value.result}</td>
                          </tr>
                        
                        </table>
                      </div>
                    )}
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityView;
